export const LOOP_MODE = {
	noRepeat: 0,
	repeatAll: 1,
	repeatOne: 2
}

export const PLAYQUEUE_FEED_MODE = {
	replace: 0,
	append: 1,
	complete: 2
}

export const ORIGIN_PLAYQUEUE_TYPES = {
	unknown: 0,
	album: 1,
	playlist: 2,
	favoriteTracks: 3,
	track: 4
}



// WEBPACK FOOTER //
// ./src/components/miniPlayer/AudioPlayer/playerConstants.js